import { StyleSheet } from 'react-native';
import { DynamicStyleSheet } from '@pulsar/core';

export default DynamicStyleSheet.create(theme => ({
  top: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: theme.colors.separator,
  },
  bottom: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: theme.colors.separator,
  },
  line: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: theme.colors.separator,
    height: 1,
  },
  xxs: {
    height: 4,
  },
  xs: {
    height: 6,
  },
  s: {
    height: 8,
  },
  m: {
    height: 12,
  },
  l: {
    height: 16,
  },
  xl: {
    height: 20,
  },
  xxl: {
    height: 24,
  },
  xxxl: {
    height: 32,
  },
}));
